import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { Tooltip } from '@liveauctioneers/hammer-ui-core/tooltip';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { memo } from 'react';

type Props = {
    className?: string;
    iconSize?: 'small' | 'large';
};

const TopBadge = ({ className = '', iconSize = 'large' }: Props) => {
    return (
        <>
            <Tooltip
                anchorSelect="#top-badge-tooltip"
                place="bottom"
            >
                <div className="flex flex-col gap-2xs py-xs">
                    <H5 color="secondary">
                        <FormattedMessage id="top_rated_header" />
                    </H5>
                    <BodySecondary>
                        <FormattedMessage id="top_message" />
                    </BodySecondary>
                </div>
            </Tooltip>

            <div
                className={cn(
                    'hui-text-label-mini flex w-[106px] cursor-pointer items-center justify-evenly gap-2xs',
                    className
                )}
                id="top-badge-tooltip"
            >
                <img
                    alt="badge"
                    className={cn('h-md', {
                        'h-[18px]': iconSize === 'small',
                    })}
                    fetchPriority="low"
                    height={iconSize === 'small' ? 18 : 24}
                    loading="lazy"
                    src="https://p1.liveauctioneers.com/dist/images/badge.svg"
                    width={iconSize === 'small' ? 18 : 25}
                />{' '}
                <FormattedMessage
                    id="top"
                    tagName="span"
                />
            </div>
        </>
    );
};

export default memo<Props>(TopBadge);
